import { StarIcon } from "lucide-react";

import { Row } from "@/components";
import { SectionProgressIndicator } from "@/components/companies/shared/SectionProgressIndicator";
import { cn } from "@/lib/utils";

export const IntakeTab = ({
  isPrimary,
  isSelected,
  label,
  onSelect,
  progress,
}: {
  isPrimary?: boolean;
  isSelected: boolean;
  label: string;
  onSelect: () => void;
  progress: { filled: number; total: number };
}) => {
  const isIncomplete = progress.total > 0 && progress.filled < progress.total;

  const render = () => (
    <button
      className={cn(
        "shrink-0 whitespace-nowrap px-4 py-2 text-sm font-medium transition-colors",
        isSelected
          ? "border-b-2 border-primary-700 text-primary-700"
          : "border-b-2 border-transparent text-slate-500 hover:text-slate-700",
      )}
      onClick={onSelect}
      type="button"
    >
      <Row className="items-center gap-1">
        {label}
        {isPrimary && (
          <StarIcon className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
        )}
        {isIncomplete && (
          <SectionProgressIndicator
            filled={progress.filled}
            total={progress.total}
          />
        )}
      </Row>
    </button>
  );

  return render();
};
